import { environment } from "src/environments/environment";

export enum ROLES {
  ADMINISTRADOR = "administrador",
  CELADOR = "celador",
}

const items = [
  {
    url: `/lugares`,
    icono: "assets/menu/lugares.svg",
    titulo: "Lugares",
    permisos: [
      ROLES.ADMINISTRADOR
    ]
  },
  {
    url: `/citofonia`,
    icono: "assets/menu/lugares.svg",
    titulo: "Citofonía",
    permisos: [
      ROLES.CELADOR
    ]
  },
  {
    url: '/visitantes',
    icono: "assets/menu/visitantes.svg",
    titulo: "Visitantes",
    permisos: [
      ROLES.ADMINISTRADOR,
      ROLES.CELADOR
    ]
  },
  {
    url: '/usuarios',
    icono: "assets/menu/visitantes.svg",
    titulo: "Usuarios",
    permisos: [
      ROLES.ADMINISTRADOR,
      ROLES.CELADOR
    ]
  },
  {
    url: '/pagos',
    icono: "assets/menu/pagos.svg",
    titulo: "Pagos",
    permisos: [
      ROLES.ADMINISTRADOR
    ]
  },
  // {
  //   url: '/facturas',
  //   icono: "assets/menu/facturacion.svg",
  //   titulo: "Facturación",
  //   permisos: [
  //     ROLES.ADMINISTRADOR
  //   ]
  // }
]
if(!environment.production){
  items.push({
    url: '/reservas',
    icono: "assets/menu/reservas.svg",
    titulo: "Reserva Espacios",
    permisos: [
      ROLES.ADMINISTRADOR
    ]
  })
}

export default items